import { Button } from '@/components/ui/button';
import OptimizedImage from '@/components/ui/optimized-image';

// ATS systems with logos
const atsSystems = [{
  name: 'Workable',
  logo: '/lovable-uploads/Workable.png'
}, {
  name: 'Ashby',
  logo: '/lovable-uploads/Ashby.png'
}, {
  name: 'Bullhorn',
  logo: '/lovable-uploads/Bullhorn.png'
}, {
  name: 'Greenhouse',
  logo: '/lovable-uploads/Greenhouse.png'
}, {
  name: 'Lever',
  logo: '/lovable-uploads/Lever.png'
}, {
  name: 'Workday',
  logo: '/lovable-uploads/Workday.png'
}, {
  name: 'Zoho Recruit',
  logo: '/lovable-uploads/ZohoRecruit.png'
}];
const IntegrationSection = () => {
  return <section className="section-padding bg-cs-off-white">
      <div className="container-custom">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-cs-dark-grey mb-3">Zero effort required from your team</h2>
          <p className="text-lg text-cs-medium-grey">Start getting candidates in hours, not weeks. Right where your team works.</p>
        </div>
        
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {atsSystems.map((system, index) => <div key={index} className="bg-white rounded-lg p-6 flex items-center justify-center shadow-sm hover:shadow-md transition-shadow duration-300">
              <OptimizedImage 
                src={system.logo} 
                alt={`${system.name} logo`} 
                className="max-w-full max-h-12"
                width={120}
                height={48}
                loading="lazy"
              />
            </div>)}
          
          {/* "43+ more ATS supported" box */}
          <div className="bg-white rounded-lg p-6 flex items-center justify-center shadow-sm hover:shadow-md transition-shadow duration-300">
            <div className="text-center">
              <p className="font-semibold text-cs-primary text-lg">43+ more</p>
              <p className="text-sm text-cs-medium-grey">ATS supported</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default IntegrationSection;